import React, { FunctionComponent, useState } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import { PetAndClinicInfo } from '@companion-professional/dctypes';
import { useSaveAnswers } from '../../hooks/useSaveAnswers';
import { SurveyDisplay } from '../../components/SurveyDisplay';
import { PageNotFound } from '../PageNotFound';
import { SURVEY_CHECKUP_PARAM } from '../../lib/surveyPath';

type SurveyParams = {
  surveyId: string;
};

interface SurveyProps {
  pet: PetAndClinicInfo;
}

export const Survey: FunctionComponent<SurveyProps> = ({ pet }) => {
  const [surveySaved, setSurveySaved] = useState(false);
  const [searchParams] = useSearchParams();
  const { saveAnswers, error: errorSavingAnswers, isPending: isSavingAnswersPending } = useSaveAnswers();
  const { surveyId } = useParams<SurveyParams>();
  if (!surveyId) {
    return <PageNotFound />;
  }
  const checkupRequestIds = searchParams.getAll(SURVEY_CHECKUP_PARAM);

  return (
    <div className="flex flex-1 flex-col items-center">
      <div className="w-full max-w-screen-xl">
        <SurveyDisplay
          surveyId={surveyId}
          pet={pet}
          surveySaved={surveySaved}
          checkupRequestIds={checkupRequestIds}
          onSurveySubmit={async (formData, survey, answeredByUserId, checkupsToAdd = []) => {
            try {
              await saveAnswers({
                surveyId: surveyId,
                version: survey.version,
                checkupRequestIds: [...checkupRequestIds, ...checkupsToAdd],
                answers: formData,
                answeredByUserId
              });
              setSurveySaved(true);
            } catch (e) {
              // The hook should handle the error, also logging here for good measure.
              console.error(e);
            }
          }}
          isSavePending={isSavingAnswersPending}
          saveError={errorSavingAnswers?.message}
        />
      </div>
    </div>
  );
};
